export default __webpack_public_path__ + "static/media/icon-safari.ee5ab224.png";